<template>
  <div class="common-card" :key="routeKey">
    <modal-filter
      :filter_invoice_id.sync="filter_invoice_id"
      :filter_salary_type.sync="filter_salary_type"
      :filter_user_id.sync="filter_user_id"
      :invoiceOptions="invoiceOptions"
      :userOptions="userOptions"
      :is_user_page="is_user_page"
    />
    <!-- handleAdminInvoiceOptions -->
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 mb-0 text-nowrap">
            <font-awesome-icon
              class="mr-50"
              icon="fa-solid fa-person-digging"
            />
            {{is_user_page ? '用戶工資記錄' : '工資記錄'}}
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div
          class="d-flex mobile-w100 align-items-center flex-wrap flex-lg-nowrap mt-1 mt-lg-0"
        >
          <el-date-picker
            class="mr-1"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
          >
          </el-date-picker>
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋"
          />
          <b-button
            variant="primary"
            class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
            @click="$bvModal.show('modal-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          >
          <!-- <b-button
            class="mobile-w100"
            :to="{
              name: 'worker-salary-preview',
              params: {
                id: filter_user_id ? filter_user_id : userData.id,
                start_date: filter_date_from,
                end_date: filter_date_to,
                ...(filter_project_id ? { project_id: filter_project_id } : {}),
              },
            }"
          >
            <feather-icon icon="FileTextIcon" />
            列印記錄
          </b-button> -->
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refSalaryListTable"
          class="position-relative"
          :items="fetchSalaries"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(prepayment)="data">
            <div
              v-if="
                data.item.prepayment_total_amount &&
                data.item.prepayment_total_amount > 0
              "
            >
              <div class="text-primary font-weight-bold">
                HK${{ formatCurrency(data.item.prepayment_total_amount) }}
              </div>
              <!-- 遍歷預支分配記錄 -->
              <div
                v-if="
                  data.item.prepayment_allocations &&
                  data.item.prepayment_allocations.length > 0
                "
              >
                <div
                  v-for="(allocation, index) in data.item
                    .prepayment_allocations"
                  :key="`allocation-${allocation.id}`"
                >
                  <b-link
                    :key="allocation.id"
                    :to="{
                      name: 'advance-payment-edit',
                      params: { id: allocation.prepayment.id },
                    }"
                    class="small text-muted"
                  >
                    {{ allocation.prepayment.prepayment_number }}
                  </b-link>
                  <span
                    v-if="index < data.item.prepayment_allocations.length - 1"
                    :key="`separator-${allocation.id}`"
                    class="small text-muted mx-1"
                  >
                  </span>
                </div>
              </div>
              <!-- 向後兼容：如果沒有 prepayment_allocations 但有舊的 prepayment 結構 -->
              <b-link
                v-else-if="
                  data.item.prepayment && data.item.prepayment.prepayment_number
                "
                :to="{
                  name: 'advance-payment-edit',
                  params: { id: data.item.prepayment.id },
                }"
                class="small text-muted"
              >
                {{ data.item.prepayment.prepayment_number }}
              </b-link>
            </div>
            <span v-else class="text-muted">--</span>
          </template>
          <template #cell(expense)="data">
            <div v-if="data.item.expense && data.item.expense.length > 0">
              <div
                v-for="(expense, index) in data.item.expense"
                :key="`expense-${expense.id}`"
              >
                <b-link
                  :key="`expense-${expense.id}`"
                  :to="{
                    name: 'expenditure-edit',
                    params: { id: expense.id },
                  }"
                >
                  {{ expense.expense_number }}</b-link
                >
              </div>
            </div>
            <!--舊-->
            <!-- <div >
              <b-link
                v-if="data.item.expense && data.item.expense.expense_number"
                :to="{
                  name: 'expenditure-edit',
                  params: { id: data.item.expense.id },
                }"
              >
                {{ data.item.expense.expense_number }}</b-link
              >
            </div> -->
          </template>

          <template #cell(salary_type)="data">
            {{
              data.item.salary_type && getSalaryType(data.item.salary_type).name
            }}
          </template>
          <template #cell(gross_salary)="data">
            <span>HK${{ formatCurrency(data.item.gross_salary) }}</span>
          </template>
          <template #cell(actual_salary)="data">
            <span>HK${{ formatCurrency(data.item.actual_salary) }}</span>
          </template>

          <template #cell(year_month)="data">
            <div v-if="data.item.reference_year && data.item.reference_month">
              {{
                data.item.reference_year ? data.item.reference_year + "年 " : ""
              }}
              {{
                data.item.reference_month
                  ? data.item.reference_month + "月"
                  : ""
              }}
            </div>
            <!-- <div v-else-if="data.item.year_month">
              {{ data.item.year_month }}
            </div> -->
          </template>
          <template #cell(payment_date)="data">
            <div v-if="data.item.payment_date">
              {{ data.item.payment_date.split("T")[0] }}
            </div>
          </template>

          <template #cell(salary_receive_method_id)="data">
            <div v-if="data.item.salary_receive_method_id">
              {{
                data.item.salary_receive_method_id &&
                getSalaryReceiveMethod(data.item.salary_receive_method_id).name
              }}
              <span v-if="data.item.check_number">
                - {{ data.item.check_number }}
              </span>
            </div>
          </template>
          <!-- <template #cell(invoice)="data">
            <b-link
              v-if="data.item.expense && data.item.expense.invoice && data.item.expense.invoice.invoice_number"
              :to="{
                name: 'invoice-edit',
                params: { id: data.item.expense.invoice.id }
              }"
              class="text-primary"
            >
              {{ data.item.expense.invoice.invoice_number }}
            </b-link>
            <span v-else class="text-muted">--</span>
          </template> -->
          <template #cell(user_id)="data">
            {{ getUser(data.item.user_id).name_cn }}
          </template>
          <template #cell(is_approved)="data">
            <feather-icon
              v-if="data.item.is_approved"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>
          <template #cell(is_rejected)="data">
            <feather-icon
              v-if="data.item.is_rejected"
              icon="CheckIcon"
              size="18"
              class="mr-50 text-success"
            />
          </template>
          <template #cell(show_details)="row">
            <b-button
              size="sm"
              @click="toggleRowDetails('project', row)"
              class="mr-2"
            >
              {{ row.detailsShowing ? "隱藏" : "顯示" }}
            </b-button>
          </template>

          <template #row-details="row">
            <div>
              <!-- <div class="info-container" v-if="row.item.invoice">
                <b-row class="p-2 backgroundColor3 mb-1">
                  <b-col cols="12">
                    <div class="row mb-50">
                      <b class="label">發票編號：</b>
                      <span>{{ row.item.invoice.invoice_number }}</span>
                    </div>

                    <div class="row mb-50">
                      <b class="label">地址：</b>
                      <span>{{ row.item.invoice.address }}</span>
                    </div>
                  </b-col>
                </b-row>
              </div> -->
              <div class="info-container">
                <div class="px-0">
                  <label
                    >PS. 應發工資 = 各項工資 + 各項佣金/花紅 + 各項其他津貼 +
                    各項逾時工作金額</label
                  >
                </div>
                <div class="px-0">
                  <label
                    >PS. 實發工資 = 各項工資 + 各項佣金/花紅 + 各項其他津貼 +
                    各項逾時工作金額 - 各項強積金(僱員) - 預支金額</label
                  >
                </div>
                <b-row
                  class="p-2 backgroundColor5 mb-1"
                  v-for="(worker, index) in row.item.salary_records"
                  :key="`cost${index}`"
                >
                  <b-col cols="12" md="4">
                    <div class="row mb-50" v-if="worker.expense">
                      <b class="label">編號：</b>
                      <span>{{ worker.expense.expense_number }}</span>
                    </div>
                    <div class="row mb-50" v-if="getWorkerData(worker.user_id)">
                      <b
                        class="label"
                        v-if="getWorkerData(worker.user_id).user_type_id === 1"
                        >員工：</b
                      >
                      <b
                        class="label"
                        v-else-if="
                          getWorkerData(worker.user_id).user_type_id === 4
                        "
                        >師傅：</b
                      >
                      <span>
                        {{
                          getWorkerData(worker.user_id).position
                            ? `[${getWorkerData(worker.user_id).position}]`
                            : ""
                        }}
                        {{ getWorkerData(worker.user_id).name_cn }}</span
                      >
                    </div>
                    <div class="row mb-50" v-if="row.item.salary_type === 1">
                      <b class="label">工資：</b>
                      <span
                        >{{ worker.working_days }}天 * ${{
                          worker.day_salary
                        }}每日 = ${{ worker.total_salary }}</span
                      >
                    </div>
                    <!-- <div class="row mb-50" v-if="worker.user && worker.user.payment_method_id == 2">
                      <b class="label">出糧月份：</b>
                     
                    <span>{{ worker.salary_year }}年 {{ worker.salary_month }}月</span>
                      
                    </div> -->
                    <div class="row mb-50" v-if="row.item.salary_type !== 1">
                      <b class="label" v-if="row.item.salary_type === 2"
                        >月薪：</b
                      >
                      <b class="label" v-if="row.item.salary_type === 3"
                        >工程薪金：</b
                      >
                      <span>${{ worker.total_salary || 0.0 }}</span>
                    </div>
                    <div class="row mb-50">
                      <b class="label">逾時工作：</b>
                      <span
                        >{{ worker.ot_hours || 0.0 }}小時 = 金額${{
                          worker.ot_amount || 0.0
                        }}</span
                      >
                    </div>
                    <div class="row mb-50">
                      <b class="label">佣金/花紅：</b>
                      <span>${{ worker.commission || 0.0 }}</span>
                    </div>
                    <div class="row mb-50">
                      <b class="label">其他津貼：</b>
                      <span
                        >${{ worker.allowance || 0.0 }}
                        {{
                          worker.allowance_remark
                            ? ` - ${worker.allowance_remark}`
                            : ""
                        }}</span
                      >
                    </div>
                    <div
                      class="row mb-50"
                      v-if="worker.mpf_employer || worker.mpf_employee"
                    >
                      <b class="label">強積金：</b>
                      <span
                        ><b>強積金(僱主)：</b>${{ worker.mpf_employer || 0.0 }}
                        <b>強積金(僱員)：</b>${{
                          worker.mpf_employee || 0.0
                        }}</span
                      >
                    </div>

                    <!-- <div class="row mb-50">
                    <b class="label">實發工資：</b>
                    <span>${{ Number(worker.total_salary) + Number(worker.commission) + Number(worker.allowance) + Number(worker.ot_amount) - Number(worker.mpf_employee) }}</span>
                  </div> -->
                  </b-col>
                  <b-col cols="12" md="4">
                    <!-- <div class="row mb-50">
                      <b class="label">收款方式：</b>
                      <span>{{
                        getSalaryReceiveMethod(
                          worker.salary_receive_method_id
                        ).name
                      }}</span>
                    </div>
                    <div
                      class="row mb-50"
                      v-if="worker.salary_receive_method_id == 1"
                    >
                      <b class="label">支票號碼：</b>
                      <span>{{ worker.check_number }}</span>
                    </div>
                    <div class="row mb-50" v-if="worker.user && worker.user.payment_method_id == 1">
                      <b class="label">開工日期：</b>
                    <span>{{ formatWorkingDate(worker.working_date) }}</span>
                    </div>
                    <div class="row mb-50" v-if="worker.user && worker.user.payment_method_id == 3">
                      <b class="label">開工日期：</b>
                      <pre>{{worker.working_date }}</pre>
                    </div> -->
                    <div class="row mb-50" v-if="worker.expense">
                      <b class="label">出糧日期：</b>
                      <span>{{ worker.expense.expense_date }}</span>
                    </div>
                    <div class="row mb-50" v-if="worker.invoice">
                      <b class="label">發票：</b>
                      <span>{{
                        `[${worker.invoice.invoice_number}] ${worker.invoice.name_cn} ${worker.invoice.address}`
                      }}</span>
                    </div>
                    <div class="row mb-50">
                      <b class="label">備註：</b>
                      <pre>{{ worker.remark || "--" }}</pre>
                    </div>
                  </b-col>
                </b-row>

                <!-- 日薪匯總卡片 -->
                <div
                  v-if="
                    row.item.salary_type === 1 &&
                    getDailySalarySummary(row.item.salary_records)
                  "
                  class="mb-1"
                >
                  <b-card
                    class="salary-summary-card"
                    style="background-color: #f0ffc2; margin-left: -1rem"
                  >
                    <h6 class="mb-1 font-weight-bold">工資匯總</h6>

                    <b-row>
                      <b-col cols="12" md="3">
                        <div class="summary-item mb-2">
                          <span class="summary-label">總逾時工作金額：</span>
                          <span class="summary-value font-weight-bold">
                            {{
                              formatCurrency(
                                getDailySalarySummary(row.item.salary_records)
                                  .totalOtAmount
                              )
                            }}
                          </span>
                        </div>
                        <div class="summary-item mb-2">
                          <span class="summary-label">總佣金/花紅：</span>
                          <span class="summary-value font-weight-bold">
                            {{
                              formatCurrency(
                                getDailySalarySummary(row.item.salary_records)
                                  .totalCommission
                              )
                            }}
                          </span>
                        </div>
                        <div class="summary-item mb-2">
                          <span class="summary-label">總其他津貼：</span>
                          <span class="summary-value font-weight-bold">
                            {{
                              formatCurrency(
                                getDailySalarySummary(row.item.salary_records)
                                  .totalAllowance
                              )
                            }}
                          </span>
                        </div>
                      </b-col>
                      <!-- <b-col cols="12" md="3">
                      <div class="summary-item mb-2">
                        <span class="summary-label">總僱主強積金：</span>
                        <span class="summary-value font-weight-bold">
                          {{ formatCurrency(getDailySalarySummary(row.item.salary_records).totalMpfEmployer) }}
                        </span>
                      </div>
                      <div class="summary-item mb-2">
                        <span class="summary-label">總僱員強積金：</span>
                        <span class="summary-value font-weight-bold">
                          {{ formatCurrency(getDailySalarySummary(row.item.salary_records).totalMpfEmployee) }}
                        </span>
                      </div>
                    </b-col> -->
                    </b-row>
                    <hr />
                    <div class="summary-item">
                      <span class="summary-label">總工資金額：</span>
                      <span class="summary-value font-weight-bold text-primary">
                        {{
                          formatCurrency(
                            getDailySalarySummary(row.item.salary_records)
                              .totalSalary
                          )
                        }}
                      </span>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </template>
          <template #cell(export)="data">
            <b-button
              v-if="
                (ability.can('print', 'user_salaries') && is_user_page) ||
                (ability.can('print', 'salaries') && !is_user_page)
              "
              variant="primary"
              @click="exportSalary(data.item)"
              >列印</b-button
            >
            <!-- <span>列印修改進行中~</span> -->
          </template>

          <!-- <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                salariesList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="ability.can('read', 'workers')"
                :to="{
                  name: 'salary-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('update', 'workers')"
                :to="{
                  name: 'salary-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'workers')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template> -->
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useSalariesList from "./useSalariesList";
import salaryStoreModule from "../salaryStoreModule";
import ModalFilter from "../modal/ModalFilter.vue";
import { getUserData } from "@/auth/utils";
import { formatWorkingDate } from "@/utils/dateFormatter";

export default {
  components: {
    ModalFilter,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
      detailKey: null,
      dateRange: null,
      userData: getUserData(),
    };
  },
  props: {
    routeKey: String,
  },
  computed: {
    handleAdminInvoiceOptions() {
      if(this.ability.can("read", "salaries")){
        return this.invoiceOptions;
      } 
      // else if (this.ability.can("admin", "user_salaries") && this.is_user_page == true) {
      //   return this.invoiceOptions;
      // }  !this.ability.can("admin", "user_salaries") && 
      else if (this.is_user_page == true) {
        // some aggregated_summaries reference_invoice_id
        if (!this.salariesList && this.salariesList.length === 0 || !this.invoiceOptions) {
          return [];
        }

        // 收集所有 aggregated_summaries 中的 reference_invoice_id
        const referencedInvoiceIds = this.salariesList
          .flatMap((salary) => salary.aggregated_summaries || [])
          .map((summary) => summary.reference_invoice_id)
          .filter((id) => id !== null && id !== undefined);

        // 去重
        const uniqueInvoiceIds = [...new Set(referencedInvoiceIds)];

        // 從 invoiceOptions 中篩選出被引用的發票
        return this.invoiceOptions.filter((invoice) =>
          uniqueInvoiceIds.includes(invoice.id)
        );
      }
    },
  },
  methods: {
    getSalaryType(salaryType) {
      if (!salaryType || !this.salaryTypeOptions?.length)
        return { name: "- -" };
      return (
        this.salaryTypeOptions.find((s) => s.id === salaryType) || {
          name: "- -",
        }
      );
    },
    // 計算日薪匯總數據
    getDailySalarySummary(salaryRecords) {
      if (!salaryRecords || salaryRecords.length <= 1) {
        return null;
      }

      return {
        totalOtAmount: salaryRecords.reduce(
          (sum, record) => sum + (Number(record.ot_amount) || 0),
          0
        ),
        totalCommission: salaryRecords.reduce(
          (sum, record) => sum + (Number(record.commission) || 0),
          0
        ),
        totalAllowance: salaryRecords.reduce(
          (sum, record) => sum + (Number(record.allowance) || 0),
          0
        ),
        // totalMpfEmployer: salaryRecords.reduce((sum, record) => sum + (Number(record.mpf_employer) || 0), 0),
        // totalMpfEmployee: salaryRecords.reduce((sum, record) => sum + (Number(record.mpf_employee) || 0), 0),
        totalSalary: salaryRecords.reduce(
          (sum, record) => sum + (Number(record.total_salary) || 0),
          0
        ),
      };
    },
    formatCurrency(amount) {
      if (!amount || amount === 0) return "0.00";
      return parseFloat(amount).toFixed(2);
    },
    toggleRowDetails(key, row) {
      this.detailKey = key;
      row.toggleDetails();
    },
    getFormatedDate(date) {
      const mm = date.getMonth() + 1;
      const dd = date.getDate();

      return [
        date.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
      ].join("-");
    },
    exportSalary(record) {
      if (!record) {
        console.error("找不到薪資記錄:");
        return;
      }

      // 簡化參數：直接使用 salary_summary_id
      const routeParams = {
        id: record.id, // 使用 salary_summary_id
      };

      // 簡化查詢參數：只需要 salary_summary_id
      const queryParams = {
        salary_summary_id: record.id, // 薪資匯總記錄 ID
        // 保留向後兼容參數（可選）
        // salary_type: record.salary_type,
        // reference_year: record.reference_year ,
        // reference_month: record.reference_month || new Date().getMonth() + 1
      };

      // 導航到預覽頁面
      this.$router
        .push({
          name: this.is_user_page ? "worker-salary-preview" : "salary-preview",
          params: routeParams,
          query: queryParams,
        })
        .catch((err) => {
          console.error("導航錯誤:", err);
        });

      console.log("導航到薪資預覽頁面，簡化參數:", {
        params: routeParams,
        query: queryParams,
      });
    },
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("salary/deleteSalary", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    getProject(id) {
      return (
        this.projectOptions?.find((project) => project.id === id) || {
          project_number: "--",
          project_name: "--",
          address: "--",
        }
      );
    },
    getWorkerData(id) {
      return this.userOptions?.find((user) => user.id === id);
    },
    getUser(id) {
      return (
        this.userOptions?.find((user) => user.id === id) || {
          name_cn: "--",
        }
      );
    },
    getExpense(id) {
      return this.expenseOptions?.find((expense) => expense.id === id) || {};
    },
    getPrepayment(id) {
      return (
        this.prepaymentOptions?.find((prepayment) => prepayment.id === id) || {
          transactions: [],
          salary_records: [],
          expense_items: [],
        }
      );
    },
    getClaim(id) {
      return (
        this.claimOptions?.find((claim) => claim.id === id) || {
          expense_items: [],
        }
      );
    },
    getProductCategory(id) {
      return (
        this.productCategoriesOptions?.find(
          (productCategory) => productCategory.id === id
        ) || {
          name: "--",
        }
      );
    },
    formatWorkingDate,
  },
  watch: {
    dateRange: {
      handler() {
        [this.filter_date_from, this.filter_date_to] = this.dateRange;
        if (typeof this.filter_date_from === "object") {
          this.filter_date_from = this.getFormatedDate(this.filter_date_from);
          this.filter_date_to = this.getFormatedDate(this.filter_date_to);
        }
      },
    },
  },
  created() {
    var to_day = new Date(new Date().setDate(new Date().getDate()));
    // 获取去年同一天的日期
    this.filter_date_from = new Date(
      new Date().setFullYear(new Date().getFullYear() - 1)
    );
    this.filter_date_to = this.getFormatedDate(to_day);
    this.dateRange = [
      this.getFormatedDate(this.filter_date_from),
      this.filter_date_to,
    ];
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "salary";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, salaryStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const getSalaryReceiveMethod = (id) => {
      if (!id || !salaryReceiveMethodOptions.value?.length)
        return { name: "- -" };
      return (
        salaryReceiveMethodOptions.value.find((s) => s.id === id) || {
          name: "- -",
        }
      );
    };

    const salaryTypeOptions = [
      { id: 1, name: "日薪" },
      { id: 2, name: "月薪" },
      { id: 3, name: "以工程項目計算" },
    ];

    const {
      fetchSalaries,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      salariesList,
      refSalaryListTable,
      refetchData,
      ability,
      refetchOption,
      userOptions,
      invoiceOptions,
      expenseOptions,
      prepaymentOptions,
      claimOptions,
      productCategoriesOptions,
      salaryReceiveMethodOptions,
      filter_invoice_id,
      filter_salary_type,
      filter_user_id,
      filter_date_from,
      filter_date_to,
      is_user_page,
    } = useSalariesList();

    return {
      fetchSalaries,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      salariesList,
      refSalaryListTable,
      refetchData,
      ability,
      refetchOption,
      userOptions,
      invoiceOptions,
      expenseOptions,
      prepaymentOptions,
      claimOptions,
      productCategoriesOptions,
      salaryReceiveMethodOptions,
      filter_invoice_id,
      filter_salary_type,
      filter_user_id,
      filter_date_from,
      filter_date_to,
      getSalaryReceiveMethod,
      salaryTypeOptions,
      is_user_page,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
